import styled from '@emotion/styled'
import { Checkbox } from '@mui/material'

export const DeleteCheckboxForm = styled(Checkbox)(() => ({
  position: 'absolute',
  right: '5.12px',
  top: '4.73px',
  border: '1px solid #AAAAAA',
  background: '#FFF',
  borderRadius: '2px',
  padding: '0',
  '&.Mui-checked': {
    color: '#FF661A',
  },
}))
